import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import {
  SegmentCriteriaPayload,
  SegmentPreviewCount,
} from '../components/segment/types'
import { Segment } from '../models/Segment'
import { AUDIENCES_PREVIEW_COUNT_URL, AUDIENCES_URL } from '../utils/urls'

const fetchSegments = (params: TableParams) =>
  SBAPI.FetchPaginated<Segment[]>(AUDIENCES_URL, params)

const fetchSegmentById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Segment>(`${AUDIENCES_URL}/${id}`, params)

const createSegment = (segment: Segment) => SBAPI.Post(AUDIENCES_URL, segment)

const updateSegment = (segment: Segment) =>
  SBAPI.Put(`${AUDIENCES_URL}/${segment.id}`, segment)

const deleteSegment = (segment: Segment) =>
  SBAPI.Delete(`${AUDIENCES_URL}/${segment.id}`)

const previewCount = (
  criteria: SegmentCriteriaPayload
): Promise<SegmentPreviewCount> =>
  SBAPI.Post<
    { criteria: SegmentCriteriaPayload },
    { status: number; data: SegmentPreviewCount }
  >(AUDIENCES_PREVIEW_COUNT_URL, { criteria }).then((res) => res.data)

export {
  createSegment,
  deleteSegment,
  fetchSegmentById,
  fetchSegments,
  previewCount,
  updateSegment,
}
